import axiosInstance from './axiosInstance';

export interface TypeOfWork {
  id: number;
  name: string;
  closed: boolean;
  section: string;
}

class TypesOfWorkApi {
  async getAllTypesOfWork(): Promise<TypeOfWork[]> {
    try {
      const response = await axiosInstance.get<TypeOfWork[]>('/TypesOfWork');
      return response.data;
    } catch (error) {
      console.error('Error fetching types of work:', error);
      throw error;
    }
  }

  async getTypeOfWork(id: number): Promise<TypeOfWork> {
    try {
      const response = await axiosInstance.get<TypeOfWork>(`/TypesOfWork/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching type of work:', error);
      throw error;
    }
  }
}

export const typesOfWorkApi = new TypesOfWorkApi();
